import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { AttendancesApi } from "../../../shared/nestjs/gd-only/services/attendances.api";
import { RequestAttendanceTempDto, ResponseAttendanceTempDto } from "../../../shared/nestjs/gd-only/dto/attendances.dto";

@Injectable()
export class AttendanceTempBloc {
  public subscriptions: Array<Subscription> = [];
  constructor(
    private attendancesApi: AttendancesApi
  ) {
  }

  dispose() {
    this.subscriptions.forEach(item => item.unsubscribe());
  }

  getAttendanceTemp(payload: RequestAttendanceTempDto) {
    return new Promise<ResponseAttendanceTempDto[]>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesApi.getAttendanceTemp(payload)
          .map(response => response.data)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  getNewTodayAttendance(payload: RequestAttendanceTempDto) {
    return new Promise<any>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesApi.getNewTodayAttendance(payload)
          .map(response => response.data)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/attendance/attendance-temp.bloc.ts